import { AUTH_COLORS, AUTH_FONT } from "../../config/authConstants";

export var authCardSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: { xs: "column", md: "row" },
  px: "24px",
  py: "28px",
  bgcolor: AUTH_COLORS.surface,
  border: "1px solid " + AUTH_COLORS.border,
  borderRadius: "16px",
  width: { xs: "100%", md: "auto" },
  maxWidth: "100%",
  boxSizing: "border-box",
};

export var authFormPanelSx = {
  width: { xs: "100%", sm: 360 },
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "stretch",
};

export var authFormInnerSx = {
  width: { xs: "100%", sm: 320 },
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: "24px",
};

export var authFormTitleSx = {
  m: 0,
  fontFamily: AUTH_FONT,
  fontSize: 28,
  fontWeight: 600,
  lineHeight: 1.2,
  color: AUTH_COLORS.primary,
  textAlign: "left",
};

export var authFormStackSx = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
};

export var authActionsSx = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 2,
};

export var authLinkButtonSx = {
  fontFamily: AUTH_FONT,
  fontSize: 16,
  fontWeight: 500,
  color: AUTH_COLORS.primary,
  textTransform: "none",
  p: 0,
  minWidth: 0,
  "&:hover": {
    backgroundColor: "transparent",
    textDecoration: "underline",
  },
};

export var authTextFieldSx = {
  width: "100%",
  "& .MuiFormLabel-root": {
    fontFamily: AUTH_FONT,
    fontSize: 16,
    fontWeight: 400,
    color: AUTH_COLORS.text,
    position: "relative",
    transform: "none !important",
    maxWidth: "100%",
    mb: "8px",
    "&.Mui-focused": {
      color: AUTH_COLORS.text,
    },
    "&.Mui-error": {
      color: AUTH_COLORS.error,
    },
  },
  /* Label sits above the field — close the outlined notch gap */
  "& .MuiOutlinedInput-notchedOutline legend": {
    display: "none",
    width: 0,
    maxWidth: 0,
    padding: 0,
  },
  "& .MuiOutlinedInput-root": {
    fontFamily: AUTH_FONT,
    fontSize: 16,
    fontWeight: 400,
    color: AUTH_COLORS.text,
    bgcolor: AUTH_COLORS.surface,
    borderRadius: "6px",
    "& fieldset": {
      borderColor: AUTH_COLORS.border,
      top: 0,
    },
    "&:hover fieldset": {
      borderColor: AUTH_COLORS.border,
    },
    "&.Mui-focused fieldset": {
      borderColor: AUTH_COLORS.primary,
      borderWidth: 1,
    },
    "&.Mui-error fieldset": {
      borderColor: AUTH_COLORS.error,
    },
    "&.Mui-disabled": {
      bgcolor: AUTH_COLORS.surface,
    },
  },
  "& .MuiOutlinedInput-input": {
    py: "12px",
    px: "12px",
    height: "auto",
    boxSizing: "border-box",
    fontSize: 16,
    "&::placeholder": {
      color: AUTH_COLORS.textSecondary,
      opacity: 1,
      fontSize: 16,
    },
  },
  "& .MuiFormHelperText-root": {
    fontFamily: AUTH_FONT,
    fontSize: 13,
    fontWeight: 500,
    mx: 0,
    mt: "8px",
    lineHeight: 1.35,
    "&.Mui-error": {
      color: AUTH_COLORS.error,
      bgcolor: AUTH_COLORS.errorBg,
      borderRadius: "4px",
      px: "8px",
      py: "6px",
    },
  },
};
